import { render, staticRenderFns } from "./followupPortraitFields.vue?vue&type=template&id=eda2e9ba"
import script from "./followupPortraitFields.vue?vue&type=script&lang=js"
export * from "./followupPortraitFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports